import React from 'react';
import useAxios from 'axios-hooks';
import { useNavigate } from 'react-router-dom';
import Container from '@material-ui/core/Container';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Box, useMediaQuery, WithWidthProps } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import withWidth from '@material-ui/core/withWidth';
import ImageList from '@material-ui/core/ImageList';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Slider from 'react-animated-slider';
import 'react-animated-slider/build/horizontal.css';
import { IProduct, IStaticInfos } from '../types';
import ProductComponent from '../components/ProductComponent';
import { Map } from '../components/Map';

import consegnaImage from '../assets/images/consegna.png';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  video: {
    width: '100%',
  },
  productsBox: {
    padding: theme.spacing(5),
    display: 'flex',
    flexDirection: 'column',
  },
  consegna: {
    backgroundColor: theme.palette.secondary.main,
    color: '#fff',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap',
    },
    '& > *': {
      flex: 1,
      margin: '5%',
      [theme.breakpoints.down('xs')]: {
        margin: 0,
        maxWidth: '100%',
        padding: '10%',
      },
    },
  },
  consegnaText: {
    maxWidth: '40%',
    [theme.breakpoints.down('xs')]: {
      maxWidth: 'unset',
    },
  },
  map: {
    width: '100%',
  },
  galleryImage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

type HomeProps = WithWidthProps;

const Home: React.FC<HomeProps> = () => {
  const classes = useStyles();
  const [{ data }] = useAxios<IStaticInfos>({
    url: 'static-info',
    params: {
      populate: {
        homeVideo: true,
        homeGallery: true,
        homeProducts: {
          populate: ['image'],
        },
        ordinaTopImage: true,
        aziendaTopImage: true,
        aziendaAlessandro: true,
        aziendaAlessia: true,
        aziendaBottomImage: true,
        negozioImage: true,
      },
    },
  });
  const theme = useTheme();
  const navigate = useNavigate();
  const mediaQueryMatchesMd = useMediaQuery(theme.breakpoints.down('md'));
  const mediaQueryMatchesXs = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <Container disableGutters className={classes.root}>
      <video autoPlay loop className={classes.video} src={data ? data.homeVideo.url : ''} />
      <Box className={classes.productsBox} bgcolor="primary.main" color="#fff">
        <Typography variant="h5">Fatti tentare dai nostri prodotti...</Typography>
        {data && (
          <ImageList
            rowHeight={'auto'}
            gap={mediaQueryMatchesMd ? 50 : 150}
            cols={mediaQueryMatchesXs ? 1 : 3}
            color={'secondary'}
            style={{ margin: 0 }}
          >
            {data.homeProducts.map((product: IProduct) => (
              <ProductComponent key={product.id} product={product} showPrice={false} linkMode />
            ))}
          </ImageList>
        )}
        <Button variant="outlined" color="secondary" style={{ alignSelf: 'center' }} onClick={() => navigate(`ordina`)}>
          Ordina online
        </Button>
      </Box>
      <Box className={classes.consegna}>
        <img src={consegnaImage} alt="" />
        <Box className={classes.consegnaText}>
          <p>
            <b>Scopri se possiamo servirti!</b>
            <br />
            <br />
            Consulta la mappa dei comuni in cui effettiamo la <b>consegna a domicilio</b>. La consegna viene effettuata
            da noi nel giorno indicato in fase di ordine!
          </p>
        </Box>
      </Box>

      <Map />

      <Slider autoplay={5000}>
        {data &&
          data.homeGallery.map((slide) => (
            <div key={slide._id} className={classes.galleryImage}>
              <img src={slide.url} alt="" />
            </div>
          ))}
      </Slider>
    </Container>
  );
};

export default withWidth()(Home);
